export function backoffMs(attempt: number, retryAfterMs?: number, random: () => number = Math.random): number {
  if (retryAfterMs && retryAfterMs > 0) return retryAfterMs
  const base = Math.min(1000 * 2 ** attempt, 300_000)
  return Math.round(base + (random() - 0.5) * base)
}
